import React, { Component } from 'react';
import { loginRequest } from "./authConfig";
import { msalInstance } from "./index";
import jwt from 'jwt-decode';


export const getToken = async (scopes) => {
    const account = msalInstance.getActiveAccount();

    const tokenRequest = {
        ...loginRequest,
        account: account
    }

    const tokenResponse = await msalInstance.acquireTokenSilent(tokenRequest);

    console.log("Username = " + getUsername())
    return tokenResponse.accessToken;
   
}

export const getUsername = () => {
    const account = msalInstance.getActiveAccount();

    return account.username;

}

export const getRoles = (token) => {
    console.log(token)
    var access = jwt(token);

    console.log(access);
    return access;
}